import React from "react";
const ErrorPage = () => <h1>Page Not found</h1>;
export default ErrorPage;
